"use client";

import { useState } from "react";
import { countries } from "@/lib/country/registry";

type CountryFlagProps = {
  code: string;
  name: string;
  className?: string;
  eager?: boolean; // Load immediately without lazy loading
};

export default function CountryFlag({ code, name, className = "", eager = false }: CountryFlagProps) {
  const lowerCode = code.toLowerCase();
  const [imageError, setImageError] = useState(false);
  
  // Find emoji fallback from country registry
  const country = countries.find(c => c.code === lowerCode);
  const emojiFlag = country?.flag || "🏳️";

  // If image failed to load, show emoji instead
  if (imageError) {
    return (
      <span 
        className={`country-flag-emoji ${className}`.trim()}
        role="img" 
        aria-label={`${name} flag`}
      >
        {emojiFlag}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/w80/${lowerCode}.png`}
      alt={`${name} flag`}
      className={`country-flag-image ${className}`.trim()}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      onError={() => setImageError(true)}
      width="22"
      height="15"
    />
  );
}